import getApiClient from '@/plugins/api-client'

export default {
    getProfileCategoryLabel(category) {
        let item = this.availableJobCategories.filter(item => {
            return item.code === category
        })

        return item[0]?.label ?? category
    },

    toggleFavorite(id) {
        const self = this,
            api = getApiClient(self.$store)

        let favorites = self.$store.state.session.favoriteWorkProfiles,
            favoriteIds = favorites.map(profile => {
                return profile['@id']
            })

        if (!favoriteIds.includes(id)) {
            favoriteIds.push(id)
        } else {
            favoriteIds = favoriteIds.filter(profileId => {
                return profileId !== id
            })
        }

        api.patch(`/contractor/favorite_workprofiles/${self.$store.state.session.user.id}`, {favoriteWorkProfiles: favoriteIds}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('setFavoriteWorkProfiles', result.data.favoriteWorkProfiles['hydra:member'])
            })
            .catch(error => {
                console.log(error)
            })
    },

    loadFavorites() {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`/contractor/favorite_workprofiles/${self.$store.state.session.user.id}`)
            .then(result => {
                self.$store.commit('setFavoriteWorkProfiles', result.data.favoriteWorkProfiles['hydra:member'])
            })
            .catch(error => {
                console.log(error)
            })
    }
}
